import React, { useState, useEffect } from "react"
import { useLocation, useHistory } from "react-router-dom"
import { HiOutlineArrowNarrowLeft } from "react-icons/hi"

function WinePage({ allWine, displayPage }) {
    const location = useLocation()
    const history = useHistory()
    const wineId = Number( location.pathname.substr(6) )
    const [ wine, setWine ] = useState([])
    const {
        title,
        description,
        imageURL,
    } = wine

    useEffect(() => {
        const getWine = () => allWine.forEach( item => item.id === wineId && setWine( item ) )
        getWine()
    }, [
        wineId,
        allWine
    ])

    const changeRoute = () => {
        displayPage()
        history.push( "/" )
    }

    return (
        <section>
            <button className="goBackBtn" onClick={changeRoute} size="20px"><HiOutlineArrowNarrowLeft /></button>
            <article className="winePage">
                <h2>{title}</h2> 
                <img src={imageURL} alt="Wine" />
                <p>{description}</p>
            </article>
        </section>
    )
}

export default WinePage
